export async function copyString(text: string): Promise<void> {
    if (navigator.clipboard) return navigator.clipboard.writeText(text);

    return fallbackCopyString(text);
}

async function fallbackCopyString(text: string) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'absolute';
    textArea.style.top = '-999999px';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        return document.execCommand('copy')
            ? Promise.resolve()
            : Promise.reject('copy failed');
    } finally {
        document.body.removeChild(textArea);
    }
}
